import React, { useState, useEffect } from 'react';
import { reportsApi } from './api/reports';

const ConversionFunnelReport = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setError('');
      try {
        const data = await reportsApi.getConversionFunnel();
        setRows(data);
      } catch (e) {
        console.error('Failed to load conversion funnel:', e);
        setError(e.message || 'Failed to load report');
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Conversion Funnel by Sales Coordinator</h2>
        <p className="text-sm text-gray-500 mt-1">
          Calls made, enquiries generated (all sources, not just calls), and converted (won) - all-time totals per SC.
        </p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-md p-3 mb-4">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}

      {isLoading ? (
        <p className="text-sm text-gray-500">Loading...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rows.map((r) => {
            return (
              <div key={r.ecode} className="bg-white border border-gray-200 rounded-lg p-5">
                <h3 className="text-base font-semibold text-gray-900 mb-4">{r.name}</h3>
                <div className="flex items-center justify-between text-sm">
                  <div className="text-center flex-1">
                    <div className="text-2xl font-bold text-gray-900">{r.calls}</div>
                    <div className="text-gray-500 mt-1">Calls</div>
                  </div>
                  <div className="text-gray-300 px-2">→</div>
                  <div className="text-center flex-1">
                    <div className="text-2xl font-bold text-blue-600">{r.enquiries}</div>
                    <div className="text-gray-500 mt-1">Enquiries</div>
                  </div>
                  <div className="text-gray-300 px-2">→</div>
                  <div className="text-center flex-1">
                    <div className="text-2xl font-bold text-emerald-600">{r.converted}</div>
                    <div className="text-gray-500 mt-1">Converted</div>
                  </div>
                </div>
              </div>
            );
          })}
          {rows.length === 0 && (
            <p className="text-sm text-gray-400 col-span-2">No data found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ConversionFunnelReport;
